import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupLaboratories: ITrialGroupLaboratoriesLoadActionCreator = () => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_LOAD
        }
    },
    LoadTrialGroupLaboratoriesByTrialGroupId: ITrialGroupLaboratoriesLoadByTrialGroupIdActionCreator = (trialGroupId) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALGROUPID,
            trialGroupId
        }
    },
    LoadTrialGroupLaboratoriesByTrialId: ITrialGroupLaboratoriesLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALID,
            trialId
        }
    },
    LoadTrialGroupLaboratoryById: ITrialGroupLaboratoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_LOAD_BY_ID,
            id
        }
    },
    LoadTrialGroupLaboratoryByLaboratoryId: ITrialGroupLaboratoryLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_LOAD_BY_LABORATORY_ID,
            laboratoryId
        }
    },
    LoadSuccess: ITrialGroupLaboratoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupLaboratoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupLaboratory: ITrialGroupLaboratorySaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialGroupLaboratorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupLaboratorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupLaboratory: ITrialGroupLaboratoryCreateActionCreator = (laboratoryId, trialGroupId) => {

        return {
            type: ACTION_TRIALGROUPLABORATORY_CREATE,
            laboratoryId,
            trialGroupId
        }
    },
    CreateSuccess: ITrialGroupLaboratoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupLaboratoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteTrialGroupLaboratory: ITrialGroupLaboratoryDeleteActionCreator = (id) => {

        return {
            type: ACTION_TRIALGROUPLABORATORY_DELETE,
            id
        }
    },
    DeleteSuccess: ITrialGroupLaboratoryDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_DELETE_SUCCESS
        }
    },
    DeleteFailure: ITrialGroupLaboratoryDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_DELETE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupLaboratory: ITrialGroupLaboratoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialGroupLaboratoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupLaboratoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupLaboratoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialGroupLaboratoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPLABORATORY_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPLABORATORY_LOAD = "ACTION_TRIALGROUPLABORATORY_LOAD",
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALGROUPID = "ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALGROUPID",
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALID = "ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALID",
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_ID = "ACTION_TRIALGROUPLABORATORY_LOAD_BY_ID",
    ACTION_TRIALGROUPLABORATORY_LOAD_BY_LABORATORY_ID = "ACTION_TRIALGROUPLABORATORY_LOAD_BY_LABORATORY_ID",
    ACTION_TRIALGROUPLABORATORY_LOAD_SUCCESS = "ACTION_TRIALGROUPLABORATORY_LOAD_SUCCESS",
    ACTION_TRIALGROUPLABORATORY_LOAD_FAILURE = "ACTION_TRIALGROUPLABORATORY_LOAD_FAILURE",

    ACTION_TRIALGROUPLABORATORY_SAVE = "ACTION_TRIALGROUPLABORATORY_SAVE",
    ACTION_TRIALGROUPLABORATORY_SAVE_SUCCESS = "ACTION_TRIALGROUPLABORATORY_SAVE_SUCCESS",
    ACTION_TRIALGROUPLABORATORY_SAVE_FAILURE = "ACTION_TRIALGROUPLABORATORY_SAVE_FAILURE",

    ACTION_TRIALGROUPLABORATORY_CREATE = "ACTION_TRIALGROUPLABORATORY_CREATE",
    ACTION_TRIALGROUPLABORATORY_CREATE_SUCCESS = "ACTION_TRIALGROUPLABORATORY_CREATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORY_CREATE_FAILURE = "ACTION_TRIALGROUPLABORATORY_CREATE_FAILURE",

    ACTION_TRIALGROUPLABORATORY_DELETE = "ACTION_TRIALGROUPLABORATORY_DELETE",
    ACTION_TRIALGROUPLABORATORY_DELETE_SUCCESS = "ACTION_TRIALGROUPLABORATORY_DELETE_SUCCESS",
    ACTION_TRIALGROUPLABORATORY_DELETE_FAILURE = "ACTION_TRIALGROUPLABORATORY_DELETE_FAILURE",

    ACTION_TRIALGROUPLABORATORY_VALIDATE = "ACTION_TRIALGROUPLABORATORY_VALIDATE",
    ACTION_TRIALGROUPLABORATORY_VALIDATE_SUCCESS = "ACTION_TRIALGROUPLABORATORY_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORY_VALIDATE_FAILURE = "ACTION_TRIALGROUPLABORATORY_VALIDATE_FAILURE",

    ACTION_TRIALGROUPLABORATORY_CLEAR = "ACTION_TRIALGROUPLABORATORY_CLEAR",

    ACTION_TRIALGROUPLABORATORY_FILTER = "ACTION_TRIALGROUPLABORATORY_FILTER";

export interface ITrialGroupLaboratoriesLoadAction {
    type: "ACTION_TRIALGROUPLABORATORY_LOAD";
}

export interface ITrialGroupLaboratoriesLoadActionCreator {
    (): ITrialGroupLaboratoriesLoadAction;
}

export interface ITrialGroupLaboratoriesLoadByTrialGroupIdAction {
    type: "ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALGROUPID";
    trialGroupId
}

export interface ITrialGroupLaboratoriesLoadByTrialGroupIdActionCreator {
    (trialGroupId): ITrialGroupLaboratoriesLoadByTrialGroupIdAction;
}

export interface ITrialGroupLaboratoriesLoadByTrialIdAction {
    type: "ACTION_TRIALGROUPLABORATORY_LOAD_BY_TRIALID";
    trialId
}

export interface ITrialGroupLaboratoriesLoadByTrialIdActionCreator {
    (trialId): ITrialGroupLaboratoriesLoadByTrialIdAction;
}

export interface ITrialGroupLaboratoryLoadSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORY_LOAD_SUCCESS";
    formData: Dtos.TrialGroupLaboratory | Dtos.TrialGroupLaboratory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratory | Dtos.TrialGroupLaboratory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryLoadSuccessAction;
}

export interface ITrialGroupLaboratoryLoadFailureAction {
    type: "ACTION_TRIALGROUPLABORATORY_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryLoadFailureAction;
}

export interface ITrialGroupLaboratoryLoadByIdAction {
    type: "ACTION_TRIALGROUPLABORATORY_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupLaboratoryLoadByIdActionCreator {
    (id: number): ITrialGroupLaboratoryLoadByIdAction;
}

export interface ITrialGroupLaboratoryLoadByLaboratoryIdAction {
    type: "ACTION_TRIALGROUPLABORATORY_LOAD_BY_LABORATORY_ID";
    laboratoryId: number;
}

export interface ITrialGroupLaboratoryLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): ITrialGroupLaboratoryLoadByLaboratoryIdAction;
}

export interface ITrialGroupLaboratorySaveAction {
    type: "ACTION_TRIALGROUPLABORATORY_SAVE";
    formData: Dtos.TrialGroupLaboratory;

}

export interface ITrialGroupLaboratorySaveActionCreator {
    (
        formData: Dtos.TrialGroupLaboratory
    ): ITrialGroupLaboratorySaveAction;
}

export interface ITrialGroupLaboratorySaveSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORY_SAVE_SUCCESS";
    formData: Dtos.TrialGroupLaboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratorySaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratorySaveSuccessAction;
}

export interface ITrialGroupLaboratorySaveFailureAction {
    type: "ACTION_TRIALGROUPLABORATORY_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratorySaveFailureAction;
}

export interface ITrialGroupLaboratoryCreateAction {
    type: "ACTION_TRIALGROUPLABORATORY_CREATE";
    laboratoryId: number | null;
    trialGroupId: number | null;
}

export interface ITrialGroupLaboratoryCreateActionCreator {
    (laboratoryId: number | null, trialGroupId: number | null): ITrialGroupLaboratoryCreateAction
}

export interface ITrialGroupLaboratoryCreateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORY_CREATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratory;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialGroupLaboratoryCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupLaboratoryCreateSuccessAction;
}

export interface ITrialGroupLaboratoryCreateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORY_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryCreateFailureAction;
}

export interface ITrialGroupLaboratoryDeleteAction {
    type: "ACTION_TRIALGROUPLABORATORY_DELETE";
    id: number;
}

export interface ITrialGroupLaboratoryDeleteActionCreator {
    (id: number): ITrialGroupLaboratoryDeleteAction
}

export interface ITrialGroupLaboratoryDeleteSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORY_DELETE_SUCCESS";
}

export interface ITrialGroupLaboratoryDeleteSuccessActionCreator {
    (): ITrialGroupLaboratoryDeleteSuccessAction;
}

export interface ITrialGroupLaboratoryDeleteFailureAction {
    type: "ACTION_TRIALGROUPLABORATORY_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryDeleteFailureAction;
}

export interface ITrialGroupLaboratoryValidateAction {
    type: "ACTION_TRIALGROUPLABORATORY_VALIDATE";
    formData: Dtos.TrialGroupLaboratory;

}

export interface ITrialGroupLaboratoryValidateActionCreator {
    (
        formData: Dtos.TrialGroupLaboratory
    ): ITrialGroupLaboratoryValidateAction;
}

export interface ITrialGroupLaboratoryValidateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORY_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryValidateSuccessAction;
}

export interface ITrialGroupLaboratoryValidateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORY_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryValidateFailureAction;
}

export interface ITrialGroupLaboratoryClearAction {
    type: "ACTION_TRIALGROUPLABORATORY_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupLaboratoryClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupLaboratoryClearAction;
}

export interface ITrialGroupLaboratoryFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupLaboratoryFilterAction;
}

export interface ITrialGroupLaboratoryFilterAction {
    type: "ACTION_TRIALGROUPLABORATORY_FILTER";
    formFilter: IFormFilter;
}

export type TrialGroupLaboratoryAction =
    ITrialGroupLaboratoriesLoadAction |
    ITrialGroupLaboratoriesLoadByTrialGroupIdAction |
    ITrialGroupLaboratoriesLoadByTrialIdAction |
    ITrialGroupLaboratoryLoadByIdAction |
    ITrialGroupLaboratoryLoadByLaboratoryIdAction |
    ITrialGroupLaboratoryLoadFailureAction |
    ITrialGroupLaboratoryLoadSuccessAction |
    ITrialGroupLaboratorySaveAction |
    ITrialGroupLaboratorySaveSuccessAction |
    ITrialGroupLaboratorySaveFailureAction |
    ITrialGroupLaboratoryCreateAction |
    ITrialGroupLaboratoryCreateSuccessAction |
    ITrialGroupLaboratoryCreateFailureAction |
    ITrialGroupLaboratoryDeleteAction |
    ITrialGroupLaboratoryDeleteSuccessAction |
    ITrialGroupLaboratoryDeleteFailureAction |
    ITrialGroupLaboratoryValidateAction |
    ITrialGroupLaboratoryValidateSuccessAction |
    ITrialGroupLaboratoryValidateFailureAction |
    ITrialGroupLaboratoryClearAction |
    ITrialGroupLaboratoryFilterAction;